import { ImportProgressSession } from '@store/reducers/accountReducer';
import {
    saveTaskProgressSession,
    loadTaskProgressSession,
    clearTaskProgressSession,
} from './taskProgressStorage';

// Only the session pointer is persisted — never per-row results, which are
// always re-fetched fresh from the backend (GET /api/task_history/session_results/)
// on remount, so a stale localStorage copy can never show outdated per-row state.
const STORAGE_KEY = 'icdl_validation_progress_session_v1';

export const saveValidationProgressSession = (session: ImportProgressSession): void =>
    saveTaskProgressSession(STORAGE_KEY, session);

export const loadValidationProgressSession = (): ImportProgressSession | null =>
    loadTaskProgressSession(STORAGE_KEY) as ImportProgressSession | null;

export const clearValidationProgressSession = (): void => clearTaskProgressSession(STORAGE_KEY);
